module.exports = __webpack_public_path__ + "img/share_title.6037b83c.png";